import { pl } from "./pl.js";
import { en } from "./en.js";
import { de } from "./de.js";
import { uk } from "./uk.js";

export var messages = { pl, en, de, uk };
